import LazyRender from './LazyRender';
export default LazyRender;